const list = [
  {module: "agrofact", filter: {type: "car", multiple: true}, id: "realtime-gps", name: "Онлайн", defaultActive: true},
  {module: "agrofact", filter: {type: "car"}, id: "car-assignments", name: "Задания"},
  {module: "agrofact", filter: {type: "car", cartypes: ["Tractor", "Combine", "PassengerCar", "Truck", "ZhatkaSamokhodnaya", "Sprayer", "Refueller"], multiple: true}, id: "refueling-list", name: "Заправочная ведомость"},
  {module: "agrofact", filter: {type: "car", multiple: true}, id: "car-gps", name: "Мультитрек"},
  {module: "agrofact", filter: {type: "car", cartypes: ["Tractor", "Combine", "PassengerCar", "Truck", "ZhatkaSamokhodnaya", "Sprayer", "Refueller"]}, id: "car-sensors", name: "Датчики"},
  {module: "agrofact", filter: {type: "car"}, id: "speedmonitoring", name: "Скоростной режим"},
  {module: "agrofact", filter: {type: "car"}, id: "downtime", name: "Простои"},
  {module: "agrofact", filter: {type: "car"}, id: "overdrive", name: "Перегоны"},
  {module: "agrofact", filter: {type: "car"}, id: "noassignments", name: "Нет заданий"},
  {module: "agrofact", filter: {type: "car"}, id: "daily-reports", name: "Отчеты"},
  {module: "agrofact", filter: {type: "car", cartypes: ["Tractor", "Combine", "Truck"], sensorType: "CombineScrew"}, id: "unloading-report", name: "Выгрузка"},
  {module: "agrofact", filter: {types: ["field", "seedlimit", "seedlimit-field"]}, id: "passport", name: "Паспорт поля", defaultActive: true},
  {module: "agrofact", filter: {types: ["field", "seedlimit", "seedlimit-field"]}, id: "seed", name: "Севооборот"},
  {module: "agrofact", filter: {types: ["field", "seedlimit", "seedlimit-field"]}, id: "field-assignments", name: "Задания"},
]

function initialState() {
  return {
    filteredList: [],
    active: null,
    height: 250,
    width: 330,
    createSeed: false
  }
}

const state = {
  ...initialState(),
};

const getters = {
  getList: (state) => {
    return state.filteredList
  },
  getActive: (state) => {
    return state.active
  },
  getHeight: (state) => {
    return state.height
  },
  getContentHeight: (state) => {
    return state.height - 26
  },
  getWidth: (state) => {
    return state.width
  },
  getContentWidth: (state) => {
    return state.width
  },
  getCreateSeed: (state) => {
    return state.createSeed
  },
};

const mutations = {
  filter: (state, {type, value, cartype, sensorType, module = "agrofact", overlay, organizationType}) => {
    state.filteredList = list.slice()
      .filter(item => item.module == module)
      .filter(item => item.organizationTypes ? item.organizationTypes.includes(organizationType) : true)
      .filter(item => item.overlay ? item.overlay == overlay : true)
      .filter(item => {
        let cond1 = item.filter.type
          ? item.filter.type == type
          : (item.filter.types && item.filter.types.includes(type))
        let cond3 = !cartype || !item.filter.cartypes || item.filter.cartypes.includes(cartype)
        let cond4 = !item.filter.sensorType || item.filter.sensorType === sensorType
        return cond1 && cond3 && cond4
      })
  },
  setDefaultActive: (state) => {
    if (state.filteredList.length) {
      let index = state.filteredList.findIndex(item => item.id == state.active)
      if (index == -1) {
        index = state.filteredList.findIndex(item => item.defaultActive)
        state.active = index != -1 ? state.filteredList[index].id : state.filteredList[0].id
      }
    }
  },
  setActive: (state, payload) => {
    state.active = payload
  },
  setHeight: (state, payload) => {
    state.height = payload
  },
  setWidth: (state, payload) => {
    state.width = payload
  },
  reset: (state) => {
    const iState = initialState()
    Object.keys(iState).forEach(key => {
      state[key] = iState[key]
    })
  },
  toggleCreateSeed: (state, payload) => {
    state.createSeed = payload
  },
};

const actions = {
  actionFilter({commit, rootGetters}, payload) {
    let organizationType = rootGetters["App/getOrganizationType"]
    commit("filter", {...payload, organizationType});
    commit("setDefaultActive");
  },
  actionSetActive({commit}, payload) {
    commit("setActive", payload);
  },
  actionSetHeight({commit}, payload) {
    let value = (payload < 250) ? 250 : payload
    commit("setHeight", value);
  },
  actionSetWidth({commit}, payload) {
    commit("setWidth", payload);
  },
  actionReset({commit}) {
    commit("reset")
  },
  actionCreateSeed({commit}, payload) {
    commit("toggleCreateSeed", payload)
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
